<div
  class="fixed bottom-0 flex justify-between w-screen h-10 max-w-full px-6 py-2 overflow-hidden text-center align-middle bg-white"
>
  <img class="h-5" src="assets/images/powered-by.svg" alt="Powered-By-Elsi" />
  <span class="pt-1 text-xs font-medium text-secondary-focus"
    >© {{ currentYear() }} Elsi INC. All rights reserved.</span
  >
</div>
